import { OrbitControls, useTexture, FirstPersonControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { Physics, RigidBody, CuboidCollider } from "@react-three/rapier";
import * as THREE from "three";
import graniteTexture from './assets/granite.jpg';
// import VideoGrp1 from "./components/VideoGrp1";
import TreeModel from "./components/TreeModel";
// import CaveModel from "./components/CaveModel";
import GrassModel from "./components/GrassModel";
import TreeModel2 from "./components/TreeModel2";
import CampfireModel from "./components/CampfireModel";
import { Suspense } from "react";

function getCirclePositions(count, radius, y = 5) {
  const positions = [];
  for (let i = 0; i < count; i++) {
    const angle = (i / count) * Math.PI * 2;
    const x = Math.cos(angle) * radius;
    const z = Math.sin(angle) * radius;
    positions.push([x, y, z]);
  }
  return positions;
}

function App() {
  const treeCount = 6;
  const treeRadius = 120;
  const treePositions = getCirclePositions(treeCount, treeRadius);

  return (
    <Canvas dpr={[1, 2]} shadows camera={{ position: [350, 550, -700], fov: 30 }}>
      <ambientLight penumbra={10} intensity={1}/>
      <pointLight position={[10, 10, 10]} intensity={0.5} />
      <spotLight
        intensity={5}
        angle={1.5}
        penumbra={1}
        position={[100, 1000, 100]}
        castShadow
      />

      <Physics>
        <Suspense fallback={null}>
          {/* Trees in a circle */}
          {treePositions.map((pos, idx) => (
            <TreeModel key={idx} position={pos} />
          ))}
        </Suspense>

        <RigidBody restitution={0}>
          <GrassModel url="/objs/grass/grass.FBX" position={[0, -5, 0]} scale={1} />
          {/* Campfire at the center */}
          <CampfireModel position={[0, 0, 0]} scale={1} />
          <TreeModel2 position={[250, 0, 0]} />
        </RigidBody>
        <CuboidCollider position={[0, -Math.PI / 2, 0]} args={[100, 0.5, 100]} />
      </Physics>

      <FirstPersonControls maxPolarAngle={Math.PI / 2} movementSpeed={30} />
      <OrbitControls maxPolarAngle={Math.PI / 2} minPolarAngle={1} />
    </Canvas>
  );
}

export default App;
